<div class="padding-24 pos-r" *ngIf="tickets.ticketsLoading">
  <app-loader></app-loader>
</div>

<div class="matrix__timeline-wrapper" *ngIf="!tickets.ticketsLoading">
  <!-- ПРИОРИТЕТНАЯ СЕКЦИЯ: Аварии на коммутаторах (всегда сверху) -->
  <div class="matrix__emergency-section">
    <ng-container *ngFor="let date of tickets.dataMatrix">
      <ng-container *ngIf="date.gp_intervals.isShow && date.gp_intervals.tickets && date.gp_intervals.tickets.length">
        <div class="gp__tickets-header">
          <div class="grid grid--gap-4">
            <div class="grid__box grid__box--size-min">
              <div class="grid grid--gap-4 cur-pointer" (click)="changeOpenedIntervals(date.gp_intervals)">
                <div class="grid__box grid__box--size-min" *ngIf="date.gp_intervals.isOpen">
                  <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                </div>
                <div class="grid__box grid__box--size-min" *ngIf="!date.gp_intervals.isOpen">
                  <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                </div>
              </div>
            </div>
            <div class="grid__box grid__box--size-min">
              <div class="ml-8">
                <app-icon [glyph]="'triangle-warning'" [size]="'16'" [color]="'red-dark'"></app-icon>
              </div>
            </div>
            <div class="grid__box grid__box--size-min font-weight-bold">Аварии на коммутаторах ({{ date.gp_intervals.tickets.length }})</div>
          </div>
        </div>
        <ng-container *ngIf="date.gp_intervals.isShow && date.gp_intervals.isOpen">
          <div class="tickets">
            <div class="tickets__column" *ngFor="let ticket of date.gp_intervals.tickets; let ticketIndex = index">
              <app-tickets-ticket-gp-new
                *ngIf="ticket.isShow"
                [ticket]="ticket"
                [ticketsCurrentFilter]="ticketsCurrentFilter"
                [filter]="filter"
                [brigadeAssign]="brigadeAssign"
                [ticketsMultipleAssign]="ticketsMultipleAssign"
              >
              </app-tickets-ticket-gp-new>
            </div>
          </div>
          <div class="matrix__line-separator"></div>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>

  <!-- EDO заявки (Исправление договоров) -->
  <div class="matrix__edo-sections" *ngFor="let date of tickets.dataMatrix">
    <!-- EDO заявки -->
    <ng-container *ngIf="date.edo_intervals.isShow && date.edo_intervals.tickets && date.edo_intervals.tickets.length">
      <div class="gp__tickets-header">
        <div class="grid grid--gap-4">
          <div class="grid__box grid__box--size-min">
            <div class="grid grid--gap-4 cur-pointer" (click)="changeOpenedIntervals(date.edo_intervals)">
              <div class="grid__box grid__box--size-min" *ngIf="date.edo_intervals.isOpen">
                <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
              </div>
              <div class="grid__box grid__box--size-min" *ngIf="!date.edo_intervals.isOpen">
                <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
              </div>
            </div>
          </div>
          <div class="grid__box grid__box--size-min">
            <div class="ml-8">
              <app-icon [glyph]="'doc'" [size]="'16'" [color]="'gray-dark'"></app-icon>
            </div>
          </div>
          <div class="grid__box grid__box--size-min font-weight-bold">Исправление договоров ({{ date.edo_intervals.tickets.length }})</div>
        </div>
      </div>
      <ng-container *ngIf="date.edo_intervals.isShow && date.edo_intervals.isOpen">
        <div class="tickets">
          <div class="tickets__column" *ngFor="let ticket of date.edo_intervals.tickets; let ticketIndex = index">
            <app-tickets-ticket-edo-new
              *ngIf="ticket.isShow"
              [ticket]="ticket"
              [ticketsCurrentFilter]="ticketsCurrentFilter"
              [filter]="filter"
              [brigadeAssign]="brigadeAssign"
              [ticketsMultipleAssign]="ticketsMultipleAssign"
            >
            </app-tickets-ticket-edo-new>
          </div>
        </div>
        <div class="matrix__line-separator"></div>
      </ng-container>
    </ng-container>
  </div>
  <!-- Контент с карточками -->
  <div class="matrix__content">
    <div class="matrix__list-date" *ngFor="let dateData of positionedTickets; let first = first; let last = last">
      <!-- Заголовок даты -->
      <div class="date-header date-header--sticky">
        <div class="date-header__title">
          <span *ngIf="dateData.date === currentDate">Сегодня</span>
          <span *ngIf="dateData.date !== currentDate">{{ dateData.date | dateFormat: 'DD.MM.YYг.' }}</span>
        </div>
        <div class="date-header__controls">
          <button type="button" class="timeline-nav__btn" (click)="scrollLocalLeft(dateTimeline, dateCards)">
            <app-icon [glyph]="'arrow-left'" [size]="'12'" [color]="'gray-dark'"></app-icon>
          </button>
          <button type="button" class="timeline-nav__btn" (click)="scrollLocalRight(dateTimeline, dateCards)">
            <app-icon [glyph]="'arrow-right'" [size]="'12'" [color]="'gray-dark'"></app-icon>
          </button>
        </div>
      </div>

      <!-- Локальная (для даты) временная шкала с независимым горизонтальным скроллом -->
      <div class="date-timeline-header">
        <div class="timeline-container" #dateTimeline (scroll)="syncHorizontalScroll(dateTimeline, dateCards)">
          <div class="timeline" [style.width.px]="totalTimelineWidth">
            <div class="timeline__hour" *ngFor="let hour of timelineHours" [style.width.px]="hourWidth">
              {{ hour }}
            </div>
          </div>
        </div>
      </div>

      <!-- Контейнер с карточками -->
      <div class="tickets-timeline__container" #dateCards (scroll)="syncHorizontalScroll(dateCards, dateTimeline)" [style.height.px]="dateData.containerHeight">
        <div class="tickets-timeline" [style.width.px]="totalTimelineWidth">
          <!-- Вертикальная линия текущего времени через карточки -->
          <div
            class="current-time-line-cards"
            *ngIf="shouldShowCurrentTime() && dateData.date === currentDate"
            [style.left.px]="getCurrentTimePosition()"
            [style.height.px]="dateData.containerHeight"
          ></div>

          <!-- Карточки заявок -->
          <div
            class="ticket-positioned"
            *ngFor="let ticket of dateData.tickets"
            [style.left.px]="ticket.position"
            [style.width.px]="ticket.width"
            [style.top.px]="ticket.row * 420"
            [ngClass]="{
              'ticket-positioned--stretched': ticket.isStretched,
              'ticket-positioned--compact': ticket.isCompact,
              'ticket-positioned--extra-compact': ticket.isExtraCompact
            }"
          >
            <!-- Сама карточка заявки -->
            <app-tickets-ticket-new
              [ticket]="ticket"
              [isCompact]="ticket.isCompact"
              [isExtraCompact]="ticket.isExtraCompact"
              [cardWidth]="ticket.width"
              [ticketsCurrentFilter]="ticketsCurrentFilter"
              [filter]="filter"
              [brigadeAssign]="brigadeAssign"
              [ticketsMultipleAssign]="ticketsMultipleAssign"
              [ngClass]="{ 'ticket--stretched': ticket.isStretched }"
            >
            </app-tickets-ticket-new>
          </div>
        </div>
      </div>

      <div class="matrix__line-separator" *ngIf="!last"></div>
    </div>
  </div>

  <!-- Сообщение об отсутствии заявок -->
  <ng-container *ngIf="!tickets.dataMatrix || (tickets.dataMatrix && !tickets.dataMatrix.length)">
    <div class="padding-24 ta-center text-italic color-gray-dark">"Заявки по заданным критериям не найдены".</div>
  </ng-container>
</div>
